import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from 'reportWebVitals';

import 'index.scss';

// https://blog.logrocket.com/multiple-entry-points-in-create-react-app-without-ejecting/ << Thanks to this dude
function importBuildTarget() {
    if (process.env.REACT_APP_BUILD_TARGET === "quoter") {
        return import("apps/QuoterApp");
    } else if (process.env.REACT_APP_BUILD_TARGET === "tickets") {
        return import("apps/TicketsApp")
    } else {
        return Promise.reject(
            new Error("No such build target: " + process.env.REACT_APP_BUILD_TARGET),
        );
    }
}

importBuildTarget().then(({default: Environment}) =>
    ReactDOM.render(
        <React.StrictMode>
            <Environment/>
        </React.StrictMode>,
        document.getElementById('root'),
    ),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
